export default function AuthHav() {
  return <></>;
}
